import { provideHrAssistantFeature } from '@core/intelligence-smart-ui';
import { AskHrChatFeatureId } from '@tellent-ask-hr/core-types';
import {
  ChatTemplatesListFeatureComponent,
  TemplatesWelcomeComponent,
} from '@tellent-ask-hr/templates-smart-ui';

import { ChatRequestFormFeatureComponent } from './chat-request-form-feature/chat-request-form-feature.component';

export const CHAT_FORMS_LIST_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Forms,
    welcomeCmp: TemplatesWelcomeComponent,
    activateCmp: ChatTemplatesListFeatureComponent,
  },
});

export const CHAT_FORM_FEATURE = provideHrAssistantFeature({
  useValue: {
    id: AskHrChatFeatureId.Form,
    welcomeCmp: null,
    activateCmp: ChatRequestFormFeatureComponent,
  },
});
